import { company as en_company } from "../en/company";

/** company — ES slice (183 keys). */
export const company: Record<keyof typeof en_company, string> = {
  company_intro_description:
    "Como local anfitrión, Linqx te ayuda a reunir a tus amigos y gestionar tus eventos.",
  company_intro_sign_in_email: "Inicia sesión con correo",
  company_intro_sign_in_code: "Inicia sesión con código",
  company_intro_trouble: "¿Problemas para iniciar sesión?",
  company_title_header: "Nombre del negocio",
  company_title_placeholder: "Añadir nombre del evento",
  company_title_hint: "Así aparecerá en Linqx y no podrás cambiarlo después.",
  company_ein_header: "EIN del negocio",
  company_ein_hint: "Introduce tu Número de Identificación de Empleador (EIN).",
  company_admin_header: "Ajustes de administrador",
  company_admin_subtitle: "Soy",
  company_admin_owner: "Propietario",
  company_admin_admin: "Administrador",
  company_admin_other: "Otro",
  company_contact_header: "Información de contacto",
  company_contact_email: "Correo",
  company_contact_phone: "Teléfono",
  company_type_header: "Tipo de negocio",
  company_type_hint: "Selecciona todas las que apliquen",
  company_welcome_rules_title: "Las fotos siguen estas normas de la casa:",
  company_welcome_rule_1_title: "Gestiona eventos",
  company_welcome_rule_1_desc:
    "Consulta, edita y gestiona todos tus eventos desde el móvil o la web.",
  company_welcome_rule_2_title: "Invitados / Reservas",
  company_welcome_rule_2_desc:
    "Consulta las listas completas de personas invitadas y confirmadas a tu evento.",
  company_welcome_rule_3_title: "Confirmaciones por QR",
  company_welcome_rule_3_desc:
    "Confirma tus reservas de forma digital dentro de la app.",
  company_welcome_rule_4_title: "Sé proactivo",
  company_welcome_rule_4_desc: "Reporta siempre el mal comportamiento.",
  company_welcome_agree: "Acepto",
  company_complete_message: "¡Tu negocio se ha registrado correctamente!",
  company_complete_start_tutorial: "Empezar tutorial",
  company_complete_skip: "Omitir",
  company_dashboard_title: "Panel",
  company_dashboard_employees: "Empleados",
  company_dashboard_employees_count: "{count} miembros del equipo",
  company_dashboard_add_employee: "Añadir empleado",
  company_dashboard_manage_team: "Gestionar equipo",
  company_dashboard_view_all: "Ver todo",
  company_employees_title: "Miembros del equipo",
  company_employees_empty: "Aún no hay miembros del equipo",
  company_employees_empty_hint:
    "Añade empleados para ayudar a gestionar tu negocio",
  company_employees_search: "Buscar empleados...",
  company_employees_add_first: "Añade tu primer empleado",
  company_employee_title: "Detalles del empleado",
  company_employee_role: "Rol",
  company_employee_contact: "Información de contacto",
  company_employee_email: "Correo",
  company_employee_phone: "Teléfono",
  company_employee_status: "Estado",
  company_employee_update_role: "Actualizar rol",
  company_employee_update_contact: "Actualizar contacto",
  company_employee_remove: "Eliminar empleado",
  company_employee_remove_confirm:
    "¿Seguro que quieres eliminar a este empleado?",
  company_add_employee_title: "Añadir miembro al equipo",
  company_add_employee_user_id: "ID de usuario",
  company_add_employee_user_id_placeholder: "Introduce el ID de usuario",
  company_add_employee_email: "Dirección de correo",
  company_add_employee_email_placeholder: "Introduce la dirección de correo",
  company_add_employee_phone: "Número de teléfono",
  company_add_employee_phone_placeholder: "Introduce el número de teléfono",
  company_add_employee_role: "Seleccionar rol",
  company_add_employee_role_hint: "Elige un rol para este miembro del equipo",
  company_add_employee_success: "Empleado añadido correctamente",
  company_add_employee_button: "Añadir empleado",
  company_role_owner: "Propietario",
  company_role_admin: "Administrador",
  company_role_moderator: "Moderador",
  company_role_staff: "Personal",
  company_status_active: "Activo",
  company_status_inactive: "Inactivo",
  company_status_suspended: "Suspendido",
  company_status_resigned: "Retirado",
  business_title: "Linqx Business",
  business_new_company: "Nuevo",
  business_no_companies: "Aún no hay empresas",
  business_no_companies_description:
    "Crea tu primera empresa para empezar a gestionar tu negocio en Linqx.",
  business_create_company: "Crear empresa",
  business_team: "Equipo",
  business_add_member: "Añadir miembro",
  business_no_team_members: "Sin miembros del equipo",
  business_no_team_members_description:
    "Añade miembros al equipo para ayudar a gestionar tu negocio.",
  business_members_count: "{count} miembro(s)",
  business_information: "Información",
  business_team_management: "Gestión del equipo",
  business_name: "Nombre",
  business_description: "Descripción",
  business_basic: "BÁSICO",
  business_members: "MIEMBROS",
  business_events_section: "EVENTOS",
  business_events: "Eventos",
  business_status: "Estado",
  business_created: "Creado",
  business_draft: "Borrador",
  business_company_not_found: "Empresa no encontrada",
  business_business_name_label: "Nombre del negocio",
  business_business_name_placeholder: "Introduce el nombre de tu negocio",
  business_business_name_appears: "Así aparecerá tu negocio en Linqx.",
  business_ein_label: "EIN",
  business_ein_placeholder: "XX-XXXXXXX",
  business_ein_error_numeric:
    "El EIN solo puede contener números (dígitos y un guion opcional).",
  business_ein_error_length:
    "El EIN debe tener exactamente 9 dígitos (XX-XXXXXXX).",
  business_save_failed: "No se pudo guardar. Inténtalo de nuevo.",
  business_ein_verification_description:
    "Introduce tu EIN para la verificación del negocio.",
  business_role_select_description: "Selecciona tu rol en este negocio.",
  business_contact_description:
    "¿Cómo pueden contactar los clientes con tu negocio?",
  business_email_label: "Correo del negocio",
  business_contact_email_invalid: "Introduce un correo electrónico válido.",
  business_email_placeholder: "hola@tunegocio.com",
  business_phone_label: "Número de teléfono",
  business_phone_placeholder: "+1 (555) 000-0000",
  business_type_select_description:
    "Selecciona las categorías que describen tu negocio.",
  business_welcome_review_description:
    "Revisa y acepta nuestras normas para negocios.",
  business_welcome_rule_1:
    "Mantén la información de tu negocio precisa y actualizada",
  business_welcome_rule_2:
    "Trata con respeto a todo el equipo y a los clientes",
  business_welcome_rule_3:
    "Cumple con tus compromisos de eventos y venta de entradas",
  business_welcome_rule_4: "Sigue siempre las normas de la comunidad de Linqx",
  business_accept_continue: "Aceptar y continuar",
  business_accepting: "Aceptando...",
  business_complete_description:
    "Tu negocio ha sido creado. Ya puedes gestionar tu equipo y empezar a crecer en Linqx.",
  business_creating: "Creando...",
  business_verifying: "Verificando...",
  business_saving: "Guardando...",
  business_sending: "Enviando...",
  business_onboarding_name_title: "Ponle nombre a tu negocio",
  business_onboarding_ein_title: "Número de identificación de empleador",
  business_onboarding_skip_ein: "No tengo un EIN",
  business_onboarding_role_title: "Tu rol",
  business_onboarding_contact_title: "Información de contacto",
  business_onboarding_type_title: "Tipo de negocio",
  business_onboarding_welcome_title: "¡Casi listo!",
  business_onboarding_complete_title: "¡Todo listo!",
  business_onboarding_step_of: "Paso {current} de {total}",
  business_onboarding_selected_count: "Continuar ({count} seleccionados)",
  business_role_owner: "Propietario",
  business_role_admin: "Administrador",
  business_role_moderator: "Moderador",
  business_role_staff: "Personal",
  business_role_owner_desc: "Control total sobre el negocio",
  business_role_admin_desc:
    "Puede gestionar el equipo y los ajustes de la empresa",
  business_role_moderator_desc: "Puede moderar contenido y gestionar reportes",
  business_role_staff_desc: "Acceso básico como miembro del equipo",
  business_role_admin_onboarding_desc: "Gestiona el equipo y los ajustes",
  business_role_moderator_onboarding_desc: "Acceso de gestión limitado",
  business_search_members: "Buscar miembros...",
  business_search_users: "Buscar usuarios...",
  business_pending: "Pendiente",
  business_invite_send: "Enviar invitación",
  business_invite_add: "Añadir al equipo",
  business_invite_pending_description:
    "No se encontró ninguna cuenta con este correo. Se creará una invitación pendiente: se añadirá automáticamente cuando se registre.",
  business_invite_direct_description: "Se añadirá de inmediato",
  business_dismiss: "Descartar",
  business_edit_role: "Editar rol",
  business_save: "Guardar",
  business_continue: "Continuar",
  business_go_to_dashboard: "Ir al panel",
  business_add_role: "Añadir rol",
  business_edit: "Editar",
  business_appoint_member: "Estás a punto de nombrar a {name} como miembro",
  business_current_role: "Rol actual: {role}",
  business_email_address_label: "Dirección de correo",
  business_email_address_placeholder: "Introduce la dirección de correo...",
  business_already_member: "Esta persona ya es miembro de esta empresa.",
  business_existing_users: "Usuarios existentes",
  business_role_label: "Rol",
  business_business_type_label: "Tipo de negocio",
  business_business_name_input_placeholder: "Nombre del negocio",
  business_business_description_placeholder:
    "Cuéntale a la gente sobre tu negocio...",
  // LIN-145 — new vs existing business on the onboarding wizard
  business_checking: "Comprobando...",
  business_title_too_short:
    "El nombre del negocio debe tener al menos 2 caracteres.",
  business_title_already_member:
    "Ya formas parte de este negocio. Ábrelo desde tu lista de negocios.",
  business_title_not_joinable:
    "Ya existe un negocio con este nombre, pero no puedes unirte desde aquí. Pide a su propietario que te invite.",
  business_title_exists_retry:
    "Ya existe un negocio con este nombre. Toca Continuar para unirte.",
  business_too_many_attempts:
    "Demasiados intentos. Espera unos minutos e inténtalo de nuevo.",
  business_join_ein_title: "Unirse a {title}",
  business_join_ein_description:
    "{title} ya está en Linqx. Introduce su EIN para confirmar que formas parte de este negocio.",
  business_join_ein_mismatch:
    "Este EIN no coincide con el del negocio. Revísalo e inténtalo de nuevo.",
  business_join_already_member:
    "Ya eres miembro de este negocio. Ábrelo desde tu lista de negocios.",
  business_join_failed: "No se pudo verificar el EIN. Inténtalo de nuevo.",
  business_role_new_org_note:
    "Esta es una organización nueva. Aunque no seas el propietario, puedes cambiarlo más adelante.",
  business_role_existing_org_note:
    "{title} ya tiene un propietario. Elige tu rol en el equipo.",
  business_type_set_by_owner:
    "El tipo de negocio lo define el propietario del negocio.",
  business_type_none_set:
    "El propietario aún no ha definido el tipo de negocio.",
  business_join_complete_description:
    "Te has unido a {title}. Puedes abrirlo cuando quieras desde tu lista de negocios.",
};
